<template>
<div class="modal fade" id="cashModal" tabindex="-1" role="dialog">
	<div class="modal-dialog">
		<div class="modal-content ">
			<div class="modal-body ">
				<div class="d-flex justify-content-between">
					<h3 class="agileinfo_sign text-center">برداشت اعتبار </h3>
					<button type="button" class="btn-close" data-bs-dismiss="modal"  id="cashModalCloseBTN"></button>
				</div>
				<h4 class="agileinfo_sign text-center" style="line-height: 2 !important;">شماره کارت یا شبا جهت واریز مبلغ درخواستی</h4>
				<small>لطفا شماره کارت یا شبا خودتان را در کادر زیر وارد کنید و روی ثبت درخواست کلیک کنید.</small>
				<div class="form-group" style="margin-top:25px	">
					<input class="form-control dir-rtl" style="display: none;" type="text" id="clearAmount" >
					<input class="form-control dir-rtl text-end" v-model="sheba" style="height: 49px;direction:ltr" type="text" >
					<span style="color:red">{{validMessage}}</span>
				</div>
				<button class="btn btn-success valid-btn mt-2 w-100" @click="sendRequest">ثبت درخواست</button>
			</div>
		</div>
	</div>
</div>
</template>
<script setup>
import { alertBox } from '@/composables/silverBox';
import axios from 'axios';
import { ref } from 'vue';
import { useAuth } from '@/store/auth'
let auth = useAuth()
let sheba = ref()
let userId = ref()
let validMessage = ref()
auth.getToken()
if(auth.token){
	sheba.value = auth.profile.sheba
	userId.value = auth.profile.id
}
function sendRequest(){
	if(sheba.value){
		if(sheba.value.length > 15){
				validMessage.value = '';
				const formData = new FormData()
				formData.append('sheba',sheba.value)
				formData.append('amount',document.getElementById('clearAmount').value)
				formData.append('token',auth.token)

				axios.post('https://radap.ir/Backend/api/account/credit/clear.php',formData)
				.then(res=>{
					if(res.data == 'exist'){
						alertBox('درخواست قبلی شما در حال بررسی است و نتیجه به شما اعلان خواهد شد')
					}else if(res.data == 'low'){
						alertBox('لطفا مبالغ کمتر را امتحان نمایید( موجودی کیف پول حداقل ۱۰۰,۰۰۰ تومان است)')
						document.getElementById('cashModalCloseBTN').click()
					}else{
						alertBox('درخواست شما ارسال شد','success')
						document.getElementById('cashModalCloseBTN').click()
				}
			})
		}else{
			alertBox('شماره وارد شده نباید کمتر از 16 رقم باشد')
		}
	}else{
		alertBox('لطفا شماره کارت یا شبا را وارد نمایید')
	}
}
</script>

<style>

</style>